import { useTranslation } from "react-i18next";
import ChevronLeftIcon from "./icons/ChevronLeftIcon";
import { cn } from "../util/cn";

type BackButtonProps = React.ComponentProps<"button"> & {
    hidden: boolean;
};

const BackButton = ({ hidden, className, ...rest }: BackButtonProps) => {
  const { t } = useTranslation();

  if (hidden) {
    return null;
  }

  return (
    <button {...rest} className={
        cn('flex flex-row items-center gap-1 text-foreground/90 focus-visible:border-ring focus-visible:ring-primary/50 focus-visible:ring-[3px] rounded py-0.5 pr-2', className)
    }>
      <ChevronLeftIcon className="size-8" />
      <span className="text-foreground font-normal ">{t("general.back")}</span>
    </button>
  );
};

export default BackButton;
